var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "w-100 h-100 d-flex flex-column align-items-center justify-content-around py-4",
    },
    [
      _c(
        "span",
        { staticClass: "font-size-150 text-center px-3", class: _vm.darkText },
        [
          _vm._v(
            _vm._s(
              _vm._f("trans")(
                'Click on the "Start" button below to create a file from scratch.'
              )
            )
          ),
        ]
      ),
      _vm._v(" "),
      _c("ButtonWithLoadingState", {
        staticClass:
          "position-relative btn btn-lg submit-btn font-size-175 vue-no-upload-start-button",
        attrs: {
          text: _vm._f("trans")("Start"),
          icon: "fa fa-arrow-right lh-inherit",
          "is-state-loading": _vm.isSubmitting,
          "show-icon-after-text": "true",
        },
        on: {
          click: function ($event) {
            $event.stopPropagation()
            $event.preventDefault()
            return _vm.noUploaderStart.apply(null, arguments)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }